import type { CatCard } from "../types";
import { apiFetch } from "./http";

export async function fetchPublishedCards() {
  return apiFetch<{ cards: CatCard[] }>("/api/v1/cards");
}

export async function fetchMyCards(token: string) {
  return apiFetch<{ cards: CatCard[] }>("/api/v1/me/cards", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function createCard(card: CatCard, token: string) {
  return apiFetch<{ card: CatCard }>("/api/v1/cards", {
    method: "POST",
    headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ card }),
  });
}

export async function deleteCard(cardId: string, token: string) {
  return apiFetch<{ ok: true; storageCleanupPending: number }>(`/api/v1/cards/${encodeURIComponent(cardId)}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function resubmitCard(card: CatCard, token: string) {
  return apiFetch<{ card: CatCard; moderationStatus: "pending" | "published" }>(`/api/v1/cards/${encodeURIComponent(card.id)}/resubmit`, {
    method: "POST",
    headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ card }),
  });
}
